import { Dispatch } from 'redux';
import { ResultadoKri } from 'common/genericTypes';
import { GETKriMotorRiscos, POSTRetryKriMotorRiscos } from 'requests/motorRiscos';
import { typedAction } from 'store/modules/base';

export interface MotorRiscosApiState {
  getKriMotorRiscos(
    dispatch: Dispatch,
    instrumentoFinanceiroGuid: string,
    stackRequest?: boolean
  ): Promise<ResultadoKri | null>;
  postRetryKriMotorRiscos(dispatch: Dispatch, instrumentoFinanceiroGuid: string, stackRequest?: boolean): Promise<void>;
}

export const MotorRiscosApiInicialState: MotorRiscosApiState = {
  getKriMotorRiscos: GETKriMotorRiscos,
  postRetryKriMotorRiscos: POSTRetryKriMotorRiscos,
};

enum MotorRiscosApiActionType {
  Update = 'motorRiscosApi/UPDATE',
  Reset = 'motorRiscosApi/RESET',
}

export const updateMotorRiscosApi = (state: MotorRiscosApiState) => {
  return typedAction(MotorRiscosApiActionType.Update, state);
};

export const resetMotorRiscosApi = () => {
  return typedAction(MotorRiscosApiActionType.Reset);
};

type MotorRiscosApiAction = ReturnType<typeof updateMotorRiscosApi | typeof resetMotorRiscosApi>;

export function motorRiscosApiReducer(
  state: MotorRiscosApiState = MotorRiscosApiInicialState,
  action: MotorRiscosApiAction
): MotorRiscosApiState {
  switch (action.type) {
    case MotorRiscosApiActionType.Update:
      return { ...action.payload };
    case MotorRiscosApiActionType.Reset:
      return { ...MotorRiscosApiInicialState };
    default:
      return state;
  }
}
